// extracted by mini-css-extract-plugin
export default {"l":"_6d27c7fbd5"};